import { render, staticRenderFns } from "./Consequence.vue?vue&type=template&id=bf4b611a&scoped=true&"
import script from "./Consequence.vue?vue&type=script&lang=js&"
export * from "./Consequence.vue?vue&type=script&lang=js&"
import style0 from "./Consequence.vue?vue&type=style&index=0&id=bf4b611a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf4b611a",
  null
  
)

export default component.exports